export default "__VITE_ASSET__42e05f9d__"